import CardComponent from "./CardComponent";

export class LastMessageContainer extends CardComponent {

}
